import { Employees } from '~/data/employees';
import { ProposalStatus } from '~/data/proposals';
import { getFormattedEmploymentValue } from '~/scenes/PeopleModule/components/Tabs/BasicTab/components/EmploymentDataForm/data';
import { convertToDateOrUndefined } from '~/utils/helpers/date';

import { WorkflowHistoryEntry } from '../../types';

type WorkflowEntry = {
  fWorkflowUid: string;
  fWorkflowStatus: ProposalStatus;
  fWorkflowGroup: string;
  fWorkflowType: string;
  fWorkflowScheduledDate: string;
  fWorkflowLastUpdated: string;
  fWorkflowUpdatedByEmpId: number;
  fWorkflowInfo: string;
};

export const mapWorkflowHistory = (
  entries: WorkflowEntry[],
  getEmployeeById: (employeeId?: number) => Employees | undefined,
): WorkflowHistoryEntry[] =>
  entries.map((entry) => {
    const updatedByEmployee = getEmployeeById(entry.fWorkflowUpdatedByEmpId);

    return {
      scheduledDate: convertToDateOrUndefined(entry.fWorkflowScheduledDate),
      updatedAt: convertToDateOrUndefined(entry.fWorkflowLastUpdated),
      status: getFormattedEmploymentValue(entry.fWorkflowStatus, '_', ' '),
      approvedBy: updatedByEmployee
        ? `${updatedByEmployee.fEmpLastName}, ${updatedByEmployee.fEmpFirstName}`
        : '',
    };
  });
